import React from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';
import { FormPart, optionAttributes, part } from '~/lib/FormCssApi';

const CheckboxesQuestion = ({ label, value, setValue, settings }) => {
    value = value || [];

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                {settings?.options && (
                    <>
                        {getOptionsFromList(settings.options).map(
                            (opt, idx) => (
                                <label
                                    key={idx}
                                    {...optionAttributes({
                                        value: opt,
                                        isSelected: value.indexOf(opt) > -1,
                                    })}
                                    className="flex items-center py-1"
                                >
                                    <input
                                        {...part(FormPart.OPTION_INPUT)}
                                        type="checkbox"
                                        value={opt}
                                        checked={value.indexOf(opt) > -1}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                setValue([...value, opt]);
                                            } else {
                                                const newValue = [...value];
                                                newValue.splice(
                                                    value.indexOf(opt),
                                                    1,
                                                );
                                                setValue(newValue);
                                            }
                                        }}
                                        className="mr-2"
                                    />
                                    <span {...part(FormPart.OPTION_LABEL)}>
                                        {opt}
                                    </span>
                                </label>
                            ),
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default CheckboxesQuestion;
